var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"banner"}},[(_vm.isReturningCustomer)?_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("New Loan Request")]),_c('p',[_vm._v(" To process your new loan request, we need to verify the information you provided on your most recent application. ")])]):_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("Let's Find your Loan")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }